module.exports = __webpack_public_path__ + "images/header-menu-icons-bbf93a32e95ae05444b7e4fda1010b3a.png";